import api from './api'
import type { User } from '@/types'

export const userProfileService = {
  getMe: async (): Promise<User> => {
    const res = await api.get('/users/me')
    return res.data.data
  },

  updateProfile: async (data: {
    firstName?: string
    lastName?: string
    avatarUrl?: string | null
  }): Promise<User> => {
    const res = await api.put('/users/me', data)
    return res.data.data
  },

  changePassword: async (
    oldPassword: string,
    newPassword: string,
    confirmPassword: string,
  ): Promise<{ message: string }> => {
    const res = await api.put('/users/me/password', {
      oldPassword,
      newPassword,
      confirmPassword,
    })
    return res.data.data
  },
  updateEmailPreferences: async (prefs: {
    emailOnEstimateSubmitted?: boolean
    emailOnEstimateApproved?: boolean
    emailOnEstimateRejected?: boolean
    emailOnProposalSigned?: boolean
    emailOnProposalViewed?: boolean
    emailOnProposalExpiring?: boolean
  }) => {
    const res = await api.put('/users/me/email-preferences', prefs)
    return res.data.data
  },
}

export default userProfileService
